
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function Positioning() {
  const { ref, isVisible } = useScrollReveal(0.2);

  return (
    <section className="py-32 md:py-40 bg-[#0B0D10] relative overflow-hidden">
      <div ref={ref} className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <p className="text-sm tracking-[0.25em] uppercase text-[#3A5F8C] mb-6 font-medium">The Problem</p>
            <h2 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-[#F5F7FA] leading-[1.1] tracking-tight mb-8">
              Most AI Initiatives Fail Before They Begin.
            </h2>

            <div className="space-y-6">
              <p className="text-xl text-[#C9CDD3] font-medium leading-relaxed">
                The problem isn't technology.<br />
                It's prioritization.
              </p>

              <p className="text-base text-[#F5F7FA]/60 leading-relaxed">
                Organizations are overwhelmed by tools, vendors, and noise — yet unsure where AI will truly impact revenue, operational efficiency, and long-term value.
              </p>
            </div>
          </div>

          <div className={`transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="relative rounded-2xl overflow-hidden w-full h-[480px]">
              <img
                src="https://public.readdy.ai/ai/img_res/2d767efe2184ee7396d6c7c542347b49.jpg"
                alt="Clarity through structure"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0D10] via-transparent to-transparent"></div>
            </div>
            <div className="mt-8 pl-1">
              <p className="text-2xl text-[#F5F7FA] font-semibold mb-6 tracking-tight">
                AI Business Partners replaces experimentation with structure.
              </p>
              <div className="flex gap-8">
                <p className="text-sm text-[#C9CDD3]/80 font-medium">We audit first.</p>
                <p className="text-sm text-[#C9CDD3]/80 font-medium">We prioritize second.</p>
                <p className="text-sm text-[#C9CDD3]/80 font-medium">We execute with discipline.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
